/**
 * This array controls the async modules
 * "selector" @string the string given to querySelectorAll(); needs to be valid for this fn
 * "moduleName" @string the file name of the module you wish to load without the extension
 * "defaultArgs" @object object of defaultArgs you wish to instantiate with
 *
 * You can also use HTML data attributes that will be converted to an object and passed to module too
 * data-test-attribute="foo" will convert to {testAttribute: 'foo'}
 *
 * JSON objects will be parsed too, as long as you print it correctly using something like :
 * htmlspecialchars(json_encode($array, ENT_QUOTES, 'UTF-8')
 */
export const moduleDefinition: ModuleDefinition[] = [
  { selector: '.section--copy-accordion', moduleName: 'Accordion', defaultArgs: {} },
  { selector: '[data-custom-controls-video]', moduleName: 'CustomControlsVideo', defaultArgs: {} },
  { selector: '[data-categorised-accordion]', moduleName: 'CategorisedAccordion' },
  { selector: '[data-custom-swiper]', moduleName: 'CustomSwiper' },
  { selector: '[data-scroll-parallax]', moduleName: 'ScrollParallax' },
  // { selector: '[data-link-card-grid]', moduleName: 'LinkCardGrid' },
  { selector: '[data-responsive-video]', moduleName: 'ResponsiveVideo' },
  { selector: '[data-page-navigation]', moduleName: 'PageNavigation' },
  { selector: '[data-page-navigation]', moduleName: 'AffixedNavigation' },
  { selector: '[data-seasonality-popup]', moduleName: 'SeasonalityPopup' },
  { selector: '[data-fish-glossary]', moduleName: 'FishGlossary' },
  { selector: '[data-modal]', moduleName: 'Modal' },
  { selector: '[data-form="depot-lookup"]', moduleName: 'DepotLookup' },
  { selector: '[data-form="login"]', moduleName: 'LoginForm' },
  { selector: '[data-animation]', moduleName: 'AnimationSetup' },
  { selector: '[data-rating]', moduleName: 'Rating' },
  { selector: '[data-map]', moduleName: 'LocationMap' },
];
